import { render, staticRenderFns } from "./desktop-footer.vue?vue&type=template&id=78ac02de&scoped=true&"
var script = {}
import style0 from "./desktop-footer.vue?vue&type=style&index=0&id=78ac02de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ac02de",
  null
  
)

component.options.__file = "desktop-footer.vue"
export default component.exports